<nav class="header-top d-none d-lg-block" aria-label="Acessibilidade">
    <div class="container header-top__inner">
        <div class="header-top__links">
            <a href="#" class="header-top__link">Acessibilidade</a>
            <a href="#main-content" class="header-top__link" (click)="skipToContent($event)">1 Ir para conteúdo</a>
            <a href="#page-end" class="header-top__link" (click)="skipToFooter($event)">2 Ir para o rodapé</a>
            <a href="https://www.saude.mg.gov.br/faleconosco/" class="header-top__link">3 Falar conosco</a>
        </div>

        <div class="header-top__actions">
            <button
                id="toggle-negative"
                class="btn"
                type="button"
                aria-label="Alternar contraste"
                [attr.aria-pressed]="isHighContrastEnabled"
                (click)="toggleHighContrast()">
                <i class="bi bi-circle-half me-2" style="color: #ffffff;"></i>
            </button>

             <div class="d-flex gap-1 m-1 align-items-end">
                <button
                    id="increase-font"
                    class="btn d-flex align-items-center icon-acessibility"
                    type="button"
                    aria-label="Aumentar tamanho da fonte"
                    (click)="increaseFontSize()">
                    <sup>+</sup>
                    A
                </button>

                <button
                    id="reset-font"
                    class="btn d-flex align-items-center icon-acessibility"
                    type="button"
                    aria-label="Redefinir tamanho da fonte"
                    (click)="resetFontSize()">
                    A
                </button>

                <button
                    id="decrease-font"
                    class="btn d-flex align-items-center icon-acessibility"
                    type="button"
                    aria-label="Diminuir tamanho da fonte"
                    (click)="decreaseFontSize()">
                    <sup>-</sup>
                    A
                </button>
            </div>
        </div>
    </div>
</nav>

<nav class="header-main navbar-expand-lg">
    <div class="container header-main__inner">
        <a class="header-main__brand" href="#" aria-label="Governo de Minas">
            <img src="assets/images/logo-minas-new.png" alt="Logo do Governo de Minas">
        </a>

        <button class="btn-collapse btn d-lg-none" type="button" data-bs-toggle="collapse"
            data-bs-target="#secondMenu" aria-expanded="false" aria-controls="secondMenu">
            <i class="bi bi-chevron-down"></i>
        </button>

        <div class="collapse d-lg-flex justify-content-end w-100" id="secondMenu">
            <ul class="header-main__nav">
                <li><a href="https://www.ouvidoriageral.mg.gov.br/simplifique-oge" target="_blank">Simplifique</a></li>
                <li><a href="https://www.mg.gov.br/estrutura-governamental" target="_blank">Órgãos do Governo</a></li>
                <li><a href="https://www.saude.mg.gov.br/transparencia/" target="_blank">Transparência</a></li>
                <li><a href="https://www.saude.mg.gov.br/" class="header-main__portal" target="_blank">Portal da Saúde</a></li>
            </ul>
        </div>
    </div>
</nav>

<div class="bg-light py-3" id="menu-secretaria">
    <div class="container">
        <div class="d-flex justify-content-between align-items-center">
            <div class="col-auto text-start">
                <img class="menu-secretaria__logo" src="assets/images/logo-wh.png" alt="Farmácia Digital">
                
            </div>
            <!-- <div class="col-auto">
                <button class="btn btn-light d-inline-flex align-items-center rounded-0" id="hamburger-btn"
                    #hamburgerBtn>
                    <i class="bi bi-list fs-3"></i>
                </button>
            </div> -->
        </div>
    </div>
</div>

<!-- Barra Lateral -->
<!-- <div class="sidebar" id="sidebar" #sidebar>
    <div class="sidebar-content">
        <ul class="list-unstyled">
            <li><a href="#" class="text-decoration-none">Opção 1</a></li>
            <li class="submenu">
                <a href="#" class="text-decoration-none">Opção 2</a>
                <ul class="list-unstyled">
                    <li><a href="#" class="text-decoration-none">Sub Opção 1</a></li>
                    <li><a href="#" class="text-decoration-none">Sub Opção 2</a></li>
                </ul>
            </li>
            <li class="submenu">
                <a href="#" class="text-decoration-none">Opção 3</a>
                <ul class="list-unstyled">
                    <li><a href="#" class="text-decoration-none">Sub Opção 1</a></li>
                </ul>
            </li>
        </ul>
    </div>
</div> -->

<!-- Backdrop -->
<!-- <div class="sidebar-backdrop" id="sidebar-backdrop"></div> -->

<!-- Menu de busca -->
<!-- <div class="py-3" id="menu-busca">
    <div class="container">
        <div class="row align-items-center text-start text-lg-start" id="menu-search">
            
            <div class="col-12 col-lg-4 mb-2 mb-lg-0">
                <span class="dosis-menu-search">O que você está procurando?</span>
            </div>
            <div class="col-12 col-lg-8">
                <div class="input-group">
                    <input type="text" class="form-control rounded-0" placeholder="Pesquisar">
                    <button class="btn btn-search rounded-0" type="button">
                        <i class="bi bi-search"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div> -->

<!-- Menu com Submenus -->
<!-- <div class="text-white py-2 menu-principal d-none d-lg-block">
    <div class="container d-flex justify-content-between p-0" id="menu-principal">
        <ul class="nav w-100 justify-content-between">
            <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle text-white" href="#" role="button" data-bs-toggle="dropdown"
                    aria-expanded="false">
                    Cidadão
                </a>
                <ul class="dropdown-menu">
                    <li><a class="dropdown-item" href="#">Serviço 1</a></li>
                    <li><a class="dropdown-item" href="#">Serviço 2</a></li>
                    <li><a class="dropdown-item" href="#">Serviço 3</a></li>
                </ul>
            </li>

            <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle text-white" href="#" role="button" data-bs-toggle="dropdown"
                    aria-expanded="false">
                    Sobre
                </a>
                <ul class="dropdown-menu">
                    <li><a class="dropdown-item" href="#">História</a></li>
                    <li><a class="dropdown-item" href="#">Missão</a></li>
                    <li><a class="dropdown-item" href="#">Equipe</a></li>
                </ul>
            </li>

            <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle text-white" href="#" role="button" data-bs-toggle="dropdown"
                    aria-expanded="false">
                    Gestor
                </a>
                <ul class="dropdown-menu">
                    <li><a class="dropdown-item" href="#">Relatórios</a></li>
                    <li><a class="dropdown-item" href="#">Planejamento</a></li>
                    <li><a class="dropdown-item" href="#">Indicadores</a></li>
                </ul>
            </li>

            <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle text-white" href="#" role="button" data-bs-toggle="dropdown"
                    aria-expanded="false">
                    Profissional
                </a>
                <ul class="dropdown-menu">
                    <li><a class="dropdown-item" href="#">Área Técnica</a></li>
                    <li><a class="dropdown-item" href="#">Cursos</a></li>
                    <li><a class="dropdown-item" href="#">Manuais</a></li>
                </ul>
            </li>

            <li class="nav-item">
                <a class="nav-link text-white" href="#">Dados da Saúde</a>
            </li>
        </ul>
    </div>
</div> -->

<div class="border-bottom border-5 border-lg-5 border-danger" id="menu-image">
    <div class="container">
        <div class="row align-items-center menu-image">
            <div class="col-lg-4 text-start text-lg-start mb-3 mb-lg-0 d-none d-lg-block">
                <img class="menu-image__logo" src="assets/images/logo-wh.png" alt="Farmácia Digital">
                
            </div>
        </div>
    </div>
</div>

<script>
    const hamburgerBtn = document.getElementById("hamburger-btn");
    const sidebar = document.getElementById("sidebar");
    const backdrop = document.getElementById("sidebar-backdrop");

    // Função para abrir/fechar o menu lateral
    hamburgerBtn.addEventListener("click", () => {
        sidebar.classList.toggle("open");
        backdrop.classList.toggle("show");
    });

    // Fechar o menu lateral ao clicar no backdrop
    backdrop.addEventListener("click", () => {
        sidebar.classList.remove("open");
        backdrop.classList.remove("show");
    });

    // Adicionar funcionalidade para abrir/fechar submenus
    const submenus = document.querySelectorAll('.submenu > a');
    submenus.forEach(submenu => {
        submenu.addEventListener('click', (e) => {
            e.preventDefault();
            submenu.parentElement.classList.toggle('open');
        });
    });
</script>
